export default "__VITE_ASSET__CkmDNno5__"